import {configureStore} from '@reduxjs/toolkit';
import userReducer from './features/user/userSlice';
import merchantReducer from './features/merchants/merchantSlice';

export const store = configureStore({
  reducer: {
    userReducer,
    merchantReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
